import router from "@/router";
import store from "@/store";
export default class OpenCalendarAction {
    date;
    constructor(date) {
        this.date = date;
    }
    async run() {
        const data = {
            action: 'ViewCalendar',
            date: this.date?.toDateString()
        };
        store.commit('setPushNotificationAction', data);
        if (router.currentRoute.value.name !== 'CampusApp') {
            await router.push({ name: 'CampusApp', query: data });
        }
        const webviewIframeEl = document.getElementById('webviewIframe');
        const contentWindow = webviewIframeEl.contentWindow;
        if (contentWindow !== null) {
            contentWindow.postMessage(data, '*');
        }
    }
}
